import {Deserializable} from './deserializable';
import {BaseModel} from './baseModel';


export class OwnerRegistrationData implements Deserializable {

  email: string;
  name: string;
  password: string;

  deserialize(input: any) {

    Object.assign(this, input);

    return this;
  }
}
